"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageKCB = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var web_1 = require("../../modules/datacenter/web");
var quote_1 = require("../../modules/quote");
var config_1 = require("../../modules/quote/config");
var qtpager_1 = require("../qtpager");
var addzxgbtn_1 = require("./shared/zxg/addzxgbtn");
/**
 * 科创板页面
 * @returns
 */
function PageKCB() {
    return (react_1.default.createElement("div", { className: "pagebankuai" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(PageKCBTable, null)));
}
exports.PageKCB = PageKCB;
function PageKCBTable() {
    var _this = this;
    var _a = (0, react_1.useState)(1), thispage = _a[0], SetThisPage = _a[1];
    var _b = (0, react_1.useState)([]), showdata = _b[0], SetShowData = _b[1];
    var _c = (0, react_1.useState)(0), sum_count = _c[0], SetSumCount = _c[1];
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var kcb_data, quote_data, showdata_back;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, web_1.KCBAshareData)(thispage, 20)];
                case 1:
                    kcb_data = _a.sent();
                    return [4 /*yield*/, (0, quote_1.getListQuoteOrFS)({
                            quotecode_list: kcb_data.data.map(function (v) { return v.quotecode; }),
                            itemlist: [
                                config_1.QuoteItem.行情代码,
                                config_1.QuoteItem.代码带链接,
                                config_1.QuoteItem.行情统一链接,
                                config_1.QuoteItem.代码,
                                config_1.QuoteItem.最新价,
                                config_1.QuoteItem.涨跌幅,
                                config_1.QuoteItem.涨跌额,
                                config_1.QuoteItem.成交量,
                                config_1.QuoteItem.成交额
                            ]
                        })];
                case 2:
                    quote_data = _a.sent();
                    showdata_back = [];
                    kcb_data.data.forEach(function (v) {
                        var backitem = v;
                        backitem.quotedata = quote_data.find(function (q) { return q[config_1.QuoteItem.行情代码].txt == v.quotecode; });
                        showdata_back.push(backitem);
                    });
                    if (kcb_data.data.length > 0) {
                        SetSumCount(kcb_data.count);
                        SetShowData(kcb_data.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getData();
    }, [thispage]);
    return (react_1.default.createElement("div", { className: "quotetable quotetable_notrbgcolor" },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "\u5E8F\u53F7"),
                    react_1.default.createElement("th", null, "\u4EE3\u7801"),
                    react_1.default.createElement("th", null, "\u4E2A\u80A1\u540D\u79F0"),
                    react_1.default.createElement("th", null, "\u76F8\u5173\u94FE\u63A5"),
                    react_1.default.createElement("th", null, "\u6700\u65B0\u4EF7"),
                    react_1.default.createElement("th", null, "\u6DA8\u8DCC\u5E45"),
                    react_1.default.createElement("th", null, "\u6DA8\u8DCC\u989D"),
                    react_1.default.createElement("th", null, "\u6210\u4EA4\u91CF"),
                    react_1.default.createElement("th", null, "\u6210\u4EA4\u989D"),
                    react_1.default.createElement("th", null, "\u88AB\u53C2\u80A1\u516C\u53F8"),
                    react_1.default.createElement("th", null, "\u53C2\u80A1\u6BD4\u4F8B"),
                    react_1.default.createElement("th", null, "\u7533\u62A5\u72B6\u6001"),
                    react_1.default.createElement("th", null, "\u52A0\u81EA\u9009"))),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement(react_1.default.Fragment, { key: index }, v.cgdata.map(function (c, index2) {
                    return react_1.default.createElement(react_1.default.Fragment, { key: index2 },
                        index2 == 0 &&
                            react_1.default.createElement("tr", { className: "".concat(index % 2 == 1 ? 'even' : '') },
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, (thispage - 1) * 20 + index + 1),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.代码带链接].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.行情统一链接].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata &&
                                    react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(v.quotedata[config_1.QuoteItem.代码].txt, ".html") }, "\u80A1\u5427"),
                                        ' ',
                                        react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/".concat(v.quotedata[config_1.QuoteItem.代码].txt, ".html") }, "\u8D44\u91D1\u6D41"),
                                        ' ',
                                        react_1.default.createElement("a", { href: "//data.eastmoney.com/stockdata/".concat(v.quotedata[config_1.QuoteItem.代码].txt, ".html") }, "\u6570\u636E"))),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.最新价].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.涨跌幅].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.涨跌额].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.成交量].html),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length }, v.quotedata && v.quotedata[config_1.QuoteItem.成交额].html),
                                react_1.default.createElement("td", null, v.cgdata[0].bcgs),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(ShowPercent, { input: v.cgdata[0].cgbl })),
                                react_1.default.createElement("td", null, v.cgdata[0].sbzt),
                                react_1.default.createElement("td", { rowSpan: v.cgdata.length },
                                    react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v.quotecode }))),
                        index2 > 0 &&
                            react_1.default.createElement("tr", { className: "".concat(index % 2 == 1 ? 'even' : '') },
                                react_1.default.createElement("td", null, v.cgdata[index2].bcgs),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(ShowPercent, { input: v.cgdata[index2].cgbl })),
                                react_1.default.createElement("td", null, v.cgdata[index2].sbzt)));
                }));
            }))),
        react_1.default.createElement("div", { className: "qtmmore" },
            react_1.default.createElement("a", { href: "http://data.eastmoney.com/kcb/", target: "_blank" }, "\u67E5\u770B\u5168\u90E8\u62DF\u4E0A\u5E02\u4F01\u4E1A\u540D\u5355>>")),
        sum_count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: sum_count, pagesize: 20, nowindex: thispage, onChangePager: function (toindex) { SetThisPage(toindex); } })));
}
function ShowPercent(props) {
    if (props.input) {
        var num = parseFloat(props.input);
        if (isNaN(num))
            return react_1.default.createElement(react_1.default.Fragment, null);
        return react_1.default.createElement(react_1.default.Fragment, null,
            num.toFixed(2),
            "%");
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
